import { defineComponent as _defineComponent } from 'vue'
import { ref, inject } from 'vue'

import { isExpandedSymbol } from '@/components/trip/sidebar/utils'

type TripSidebarItemColorVariant =
  | 'accommodationRed'
  | 'assistantPurple'
  | 'expenseYellow'
  | 'documentBlue'
  | 'listYellow'
  | 'travelplanGreen'
  | 'photoRed'
  | 'chatBlue'
  | 'primary'
  | 'gray'

export interface SidebarSectionItemProps {
  text: string
  image?: string
  icon?: string
  color?: TripSidebarItemColorVariant
  isActive?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripSidebarSectionItem',
  props: {
    text: null,
    image: null,
    icon: null,
    color: null,
    isActive: { type: Boolean }
  },
  setup(__props: any) {

const backgroundColorMap = {
  accommodationRed: 'bg-accommodationRed',
  assistantPurple: 'bg-assistantPurple',
  expenseYellow: 'bg-expenseYellow',
  documentBlue: 'bg-documentBlue',
  listYellow: 'bg-listYellow',
  travelplanGreen: 'bg-travelplanGreen',
  photoRed: 'bg-photoRed',
  chatBlue: 'bg-chatBlue',
  primary: 'bg-primary-500',
  gray: 'bg-zinc-600',
} as const satisfies Record<TripSidebarItemColorVariant, string>

const borderColorMap = {
  accommodationRed: 'border-r-accommodationRed',
  assistantPurple: 'border-r-assistantPurple',
  expenseYellow: 'border-r-expenseYellow',
  documentBlue: 'border-r-documentBlue',
  listYellow: 'border-r-listYellow',
  travelplanGreen: 'border-r-travelplanGreen',
  photoRed: 'border-r-photoRed',
  chatBlue: 'border-r-chatBlue',
  primary: 'border-r-primary-500',
  gray: 'border-r-gray-500',
} as const satisfies Record<TripSidebarItemColorVariant, string>



const isExpanded = inject(isExpandedSymbol, ref())

return { __sfc: true,backgroundColorMap, borderColorMap, isExpanded }
}

})